import { platform, tabNames, TEST_IDS } from '@va/constants';
import { setActiveTab } from '@va/dashboard/actions/ui';
import { VisaNestedPageNavigation } from '@va/dashboard/components';
import { getWebsitePlatform } from '@va/dashboard/selectors/core';
import { PageHeader, TitleAndContextMenu } from '@va/dashboard/shared/ui-layout';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useLoadScriptFromCookie } from '@va/dashboard/util-hooks';
import { ManualSnippetInstallationIcon, NativeSnippetIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { adPlatformCookieName } from '@va/standalone/shared/constants';
import { buildNestedNavigation, buildNestedRoute } from '@va/util/helpers';
import { SsrOnboarding } from '@va/wix/shared/components';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TrackingCodeDetails from './TrackingCodeDetails';
import { TrackingCodeNative } from './TrackingCodeNative';

export const TrackingCodeTab = () => {
  useLoadScriptFromCookie(adPlatformCookieName);

  const translate = useTranslate();
  const dispatch = useDispatch();
  const websitePlatform = useSelector(getWebsitePlatform);

  useEffect(() => {
    dispatch(setActiveTab(tabNames.trackingCode));
  }, [dispatch]);

  if (websitePlatform === platform.WIX) {
    return <SsrOnboarding />;
  }

  const subRoutes = useMemo(
    () =>
      buildNestedNavigation([
        buildNestedRoute({
          link: '/manual',
          label: translate('tab.trackingCodeV2.manual'),
          tooltip: 'tooltipTab.trackingCodeV2.manual',
          component: TrackingCodeDetails,
          icon: ManualSnippetInstallationIcon,
          'data-testid': TEST_IDS.specific.nestedNavigationLinks.trackingCode.manual,
        }),
        buildNestedRoute({
          link: '/native',
          label: translate('tab.trackingCodeV2.native'),
          tooltip: 'tooltipTab.trackingCodeV2.native',
          component: TrackingCodeNative,
          icon: NativeSnippetIcon,
          'data-testid': TEST_IDS.specific.nestedNavigationLinks.trackingCode.native,
        }),
      ]),
    [],
  );

  return (
    <>
      <PageHeader
        title={
          <TitleAndContextMenu
            title={translate('all.trackingCode.title')}
            tooltipTransKey={'tooltipTab.trackingCode'}
          />
        }
        hideDatePicker
        hideBorder
      />
      <VisaNestedPageNavigation routes={subRoutes} />
    </>
  );
};
